import './flipAnimation.css';

function FlipAnimation() {
  return (
    <div>
      <div className="cubespinner">
        <h1 dir="auto" className="face1">
          heartbeat
        </h1>
        <h1 dir="auto" className="face2">
          oxygen
        </h1>
        <h1 dir="auto" className="face3">
          Stress level
        </h1>
        <h1 dir="auto" className="face4">
          suger level
        </h1>
      </div>
    </div>
  );
}

export default FlipAnimation;
